import React, { lazy } from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';

import withRouter from '../../hoc/withRouter';
import Login from '../Login';
import ForgotPassword from '../ForgotPassword';
import UnusualAccessLock from '../UnusualAccessLock';
import UnusualAccessUnblock from '../UnusualAccessUnblock';

import AuthenticatedOutlet from './AuthenticatedOutlet';

const CreateAccount = lazy(() => import('../Signup'));
const VerifyNewEmailRouter = lazy(() => import('../Profile/UpdateEmail/VerifyNewEmailRouter'));

const PublicRoutes = props => (
  <Routes>
    <Route element={<AuthenticatedOutlet />}>
      <Route path="/signup" element={<CreateAccount />} />
      <Route path="/login" element={<Login />} />
    </Route>
    <Route path="/forgot-password" element={<ForgotPassword {...props} />} />
    <Route path="/unusual-access-unblock" element={<UnusualAccessUnblock {...props} />} />
    <Route path="/unusual-access-lock" element={<UnusualAccessLock {...props} />} />
    <Route path="/update-email-process/*" element={<VerifyNewEmailRouter />} />

    {!props.isAuthenticated && <Route path="*" element={<Navigate to="/login" />} />}
  </Routes>
);

export default withRouter(PublicRoutes);
